import * as React from 'react';
import { headingSectiondepthContext } from './context';
export function useHeadingSectiondepth() {
    var headingSectiondepth = React.useContext(headingSectiondepthContext);
    return headingSectiondepth;
}
